var _circle, _circle2, _circle3, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgPaceman(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "lds-pacman",
    style: {
      background: "rgba(0, 0, 0, 0) none repeat scroll 0% 0%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "ng-attr-style": "display:{{config.showBean}}",
    style: {
      display: "block"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 50,
    r: 4,
    "ng-attr-fill": "{{config.c2}}",
    fill: "#9df871"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "linear",
    values: "95;35",
    keyTimes: "0;1",
    dur: 1,
    begin: "-0.67s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    calcMode: "linear",
    values: "0;1;1",
    keyTimes: "0;0.2;1",
    dur: 1,
    begin: "-0.67s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 50,
    r: 4,
    "ng-attr-fill": "{{config.c2}}",
    fill: "#9df871"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "linear",
    values: "95;35",
    keyTimes: "0;1",
    dur: 1,
    begin: "-0.33s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    calcMode: "linear",
    values: "0;1;1",
    keyTimes: "0;0.2;1",
    dur: 1,
    begin: "-0.33s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 50,
    r: 4,
    "ng-attr-fill": "{{config.c2}}",
    fill: "#9df871"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "linear",
    values: "95;35",
    keyTimes: "0;1",
    dur: 1,
    begin: "0s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    calcMode: "linear",
    values: "0;1;1",
    keyTimes: "0;0.2;1",
    dur: 1,
    begin: "0s",
    repeatCount: "indefinite"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate({{config.showBeanOffset}} 0)",
    transform: "translate(-15 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 50L20 50A30 30 0 0 0 80 50Z",
    "ng-attr-fill": "{{config.c1}}",
    fill: "#51CACC"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 50 50;45 50 50;0 50 50",
    keyTimes: "0;0.5;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50 50L20 50A30 30 0 0 1 80 50Z",
    "ng-attr-fill": "{{config.c1}}",
    fill: "#51CACC"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 50 50;-45 50 50;0 50 50",
    keyTimes: "0;0.5;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaceman);
export default __webpack_public_path__ + "static/media/paceman.8037484e62aff77233572f389c6652d9.svg";
export { ForwardRef as ReactComponent };